export default "__VITE_ASSET__BXzmphht__"